/**
 * @file SceneRotationForm.style.js
 * Exports SceneRotationForm component styles.
 */

export default theme => ({
  textField: {
    width: '100%',
    marginTop: theme.spacing.unit * 2
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit
  }
});



// WEBPACK FOOTER //
// ./src/components/SceneRotationForm/SceneRotationForm.style.js